import { Injectable } from '@angular/core';
import { DataStore } from './common/data-store';
import { NavigationService } from './navigation-service.service';
import { Observable } from 'rxjs';

export interface NavigationLink {
  name: string;
  title: string;
  children?: NavigationLink[];
  isActive?: string;
  shortTitle?: string;
  url?: string;
  altText?: string;
  image?: string;
  isRouter?: string;
}

export interface QueryParam {
  navIds: string[];
  paramName: string;
  paramValue: string;
}

@Injectable()
export class NavigationStoreService extends DataStore<NavigationLink[]> {
  constructor(private navigationService: NavigationService) {
    super();
  }

  public populateStore(
    appName: string,
    accessOptions: string,
    domain: string,
    userRoles$: Observable<string>
  ): Observable<NavigationLink[]> {
    this.navigationService
      .getNav(appName, accessOptions, domain, userRoles$)
      .subscribe((newData: NavigationLink[]) => {
        if (!!newData) {
          this.setData(newData);
        }
      });
    return this.getData();
  }

  private findNavLinkByName(navId: string, navData: NavigationLink[]): NavigationLink {
    let navLink: NavigationLink;
    if (navData !== undefined && navData.length > 0) {
      for (let link of navData) {
        const Link: NavigationLink = navData.find(link => link.name === navId);
        if (Link !== undefined) {
          return Link;
        }

        if (!!link.children && link.children.length > 0) {
          navLink = this.findNavLinkByName(navId, link.children);
        }
        if (!!navLink) {
          break;
        }
      }
    }
    return navLink;
  }

  public addQueryParam(params: QueryParam[]): void {
    this.getData().subscribe(navLinks => {
      const NavData: NavigationLink[] = navLinks;
      if (NavData.length > 0)
        params.map(param => {
          param.navIds.map(id => {
            if (!!id) {
              const nLink = this.findNavLinkByName(id.trim(), NavData);
              console.log(nLink);
              if (!!nLink && !!nLink.url) {
                this.appendParmaToUrl(nLink, param.paramName, param.paramValue);
              }
            }
          });
        });
    });
  }

  private appendParmaToUrl(navLink: NavigationLink, paramName: string, paramValue: string) {
    if (navLink.url.indexOf(paramName) > 0) {
      navLink.url = navLink.url.split(paramName)[0].concat(`${paramName}=${paramValue}`);
    } else if (navLink.url.indexOf('?') > 0) {
      navLink.url = navLink.url.concat(`&${paramName}=${paramValue}`);
    } else {
      navLink.url = navLink.url.concat(`?${paramName}=${paramValue}`);
    }
  }
}
